import(/* webpackMode: "eager" */ "/usr/src/app/training-portal/src/app/global-error.tsx")